import React, { useCallback, useEffect, useLayoutEffect } from 'react';
import Animated from 'react-native-reanimated';
import { useAppSelector } from 'store/hooks';
import { AppView, Button, ButtonGroup, rem, SCROLL_INDICATOR_INSETS, withAnimatedNavigationHeader, } from 'design-system';
import { HEIGHT } from 'design-system/Button';
import FeatureSupportCard from 'design-system/FeatureSupportCard';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import StatusBar from 'design-system/StatusBar';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { useCompleteSetupSteps } from 'features/feed/components/completeSetup/useCompleteSetupSteps';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import { selectUserTier } from 'features/premium/selectors/tier';
import { logDeleteSupportScreen } from './analytics';
import useNavigateToDeleteDiscountStep from './hooks/useNavigateToDiscountStep';
const strings = {
    haveYouTriedLooking: 'Have you tried looking for help?',
    ourTeamCanHelp: 'Our team and help desk can help you find the solution to your problem',
    takeMeBack: 'Take me back',
    deleteAnyway: 'Delete anyway',
};
const DeleteSupportScreen = withAnimatedNavigationHeader(({ navigation, scrollHandler }) => {
    useLayoutEffect(() => {
        navigation.setOptions({
            headerRight: () => <HelpScreenButton />,
        });
    }, []);
    useEffect(() => {
        logDeleteSupportScreen('delete');
    }, []);
    const { stepsToComplete } = useCompleteSetupSteps();
    const { navigateToDeleteDiscountStep, isFetchingDeleteDiscount } = useNavigateToDeleteDiscountStep();
    const onPressDelete = useCallback(() => {
        if (stepsToComplete.length) {
            navigation.navigateDeprecated('DeleteCompleteSetup');
        }
        else {
            navigateToDeleteDiscountStep();
        }
    }, [navigateToDeleteDiscountStep, stepsToComplete]);
    const onPressBack = useCallback(() => {
        navigation.popToTop();
    }, []);
    const { paddingHorizontalStyle } = useAppFrameDimensions();
    const paddingBottom = useMarginBottom('paddingBottom', HEIGHT * 2 + rem(16), paddingHorizontalStyle);
    const userTier = useAppSelector(selectUserTier);
    return (<AppView withFrame={false}>
          <StatusBar barStyle="dark-content" animated/>
          <Animated.ScrollView onScroll={scrollHandler} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS} scrollEventThrottle={16} contentContainerStyle={paddingBottom}>
            <ScreenInfoHeader title={strings.haveYouTriedLooking} subTitle={strings.ourTeamCanHelp} smallSubTitle/>
            <FeatureSupportCard tier={userTier}/>
          </Animated.ScrollView>
          <ButtonGroup type="floating">
            <Button title={strings.deleteAnyway} brandReversed onPress={onPressDelete} testID="deleteButton" isFetching={isFetchingDeleteDiscount}/>
            <Button title={strings.takeMeBack} brand onPress={onPressBack} testID="backButton"/>
          </ButtonGroup>
        </AppView>);
}, ({ colors }) => ({
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
    hideTitleOnScroll: true,
}));
export default DeleteSupportScreen;
